module.exports = __webpack_public_path__ + "img/0Q3A2626_L_Wood_MockedUp.83e5c748.jpg";